import * as THREE from 'three';
import vHatchingShader from '../shaders/hatching_vert.glsl'
import fHatchingShader from '../shaders/hatching_frag.glsl'

export class HatchingMaterial extends THREE.ShaderMaterial {
  constructor({ parameters, lights = true, skinning = false, hatchingMap = null }) {

    parameters = parameters || {};

    var defines = {};

    var uniforms = THREE.UniformsUtils.merge([

      THREE.UniformsLib.common,
      THREE.UniformsLib.specularmap,
      THREE.UniformsLib.envmap,
      THREE.UniformsLib.aomap,
      THREE.UniformsLib.lightmap,
      THREE.UniformsLib.emissivemap,
      THREE.UniformsLib.fog,
      THREE.UniformsLib.lights,
      {
        emissive: { value: new THREE.Color(0x000000) },
        offsetRepeat: { value: new THREE.Vector4(0, 0, 1, 1) },
        hatchingScale: { type: "f", value: 1.0 },
        hatchingMap: { type: "t", value: null },
        contrast: { type: "f", value: 1 },
        mixDiffuse: { type: "f", value: 0 },
        shadowDarkness: { type: "f", value: 1 },
        heightMap: { type: "t", value: null },
        heightMapSize: { type: "f", value: 1 },
        heightMapHeight: { type: "f", value: 1.5 },
        useHeightMapDisplacement: { type: "int", value: 0 },
        time: { type: "float", value: 0 },
        blackLevel: { type: "float", value: 0 },
        whiteLevel: { type: "float", value: 1 },
      }
    ]);

    var vertexShader = vHatchingShader;
    var fragmentShader = fHatchingShader;

    super({
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
      uniforms: uniforms,
      defines: defines
    });

    this.setValues(parameters);
    this.extensions.derivatives = true;

    this.lights = lights;
    this.skinning = skinning;

    if (hatchingMap) {
      this.hatchingMap = hatchingMap;
    }
  }

  set map(v) {
    this.uniforms.offsetRepeat.value.set(v.offset.x, v.offset.y, v.repeat.x, v.repeat.y);
    this.uniforms.map.value = v;
  }
  get map() {
    return this.uniforms.map.value;
  }


  set heightMap(v) {
    this.uniforms.heightMap.value = v;
  }
  get heightMap() {
    return this.uniforms.heightMap.value;
  }

  set heightMapSize(v) {
    this.uniforms.heightMapSize.value = v;
  }
  get heightMapSize() {
    return this.uniforms.heightMapSize.value;
  }

  set heightMapHeight(v) {
    this.uniforms.heightMapHeight.value = v;
  }
  get heightMapHeight() {
    return this.uniforms.heightMapHeight.value;
  }

  set useHeightMapDisplacement(v) {
    this.uniforms.useHeightMapDisplacement.value = v;
  }
  get useHeightMapDisplacement() {
    return this.uniforms.useHeightMapDisplacement.value;
  }

  set hatchingScale(v) {
    this.uniforms.hatchingScale.value = v;
  }
  get hatchingScale() {
    return this.uniforms.hatchingScale.value;
  }

  set shadowDarkness(v) {
    this.uniforms.shadowDarkness.value = v;
  }
  get shadowDarkness() {
    return this.uniforms.shadowDarkness.value;
  }

  set blackLevel(v) {
    this.uniforms.blackLevel.value = v;
  }
  get blackLevel() {
    return this.uniforms.blackLevel.value;
  }
  set whiteLevel(v) {
    this.uniforms.whiteLevel.value = v;
  }
  get whiteLevel() {
    return this.uniforms.whiteLevel.value;
  }

  set hatchingMap(v) {
    this.uniforms.hatchingMap.value = v;
  }

  get hatchingMap() {
    return this.uniforms.hatchingMap.value;
  }

  set color(v) {
    this.uniforms.diffuse.value = v;
  }
  get color() {
    return this.uniforms.diffuse.value;
  }

  set contrast(v) {
    this.uniforms.contrast.value = v;
  }
  get contrast() {
    return this.uniforms.contrast.value;
  }

  set mixDiffuse(v) {
    this.uniforms.mixDiffuse.value = v;
  }
  get mixDiffuse() {
    return this.uniforms.mixDiffuse.value;
  }

  set time(v) {
    this.uniforms.time.value = v;
  }
  get time() {
    return this.uniforms.time.value;
  }

  set opacity(v) {
    if (this.uniforms) {
      this.uniforms.opacity.value = v;
    } else {
      super.opacity = v;
    }
  }
  get opacity() {
    return this.uniforms.opacity.value;
  }

}